import { render, staticRenderFns } from "./muUploadEnclosure.vue?vue&type=template&id=54b453c4"
import script from "./muUploadEnclosure.vue?vue&type=script&lang=js"
export * from "./muUploadEnclosure.vue?vue&type=script&lang=js"
import style0 from "./muUploadEnclosure.vue?vue&type=style&index=0&id=54b453c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports